import React, { useState, useEffect, useRef } from "react";
import "./ScientificCalculator.css";
// import * as math from "mathjs";
// import { evaluate } from "mathjs";
import { createSoftTag, updateSoftTag } from "../../ReportManagement/service";
// import { evaluate } from "mathjs";
import { toast } from "react-toastify";

export const ScientiFicCalculator = function ScientificCalculator(props) {
  // const [Result, setResult] = useState();
  // const [selectedActualFormula, setselectedActualFormula] = useState();
  const [matchList, setMatchList] = useState();
  const [selectedFormula, setselectedFormula] = useState();
  const [hasemptyParentheses, setHasEmptyParentheses] = useState(false);
  const [multiple_Consecutive_Operators, setmultiple_Consecutive_Operators] =
    useState(false);
  const [formula_Starts_With_Operator, setformula_Starts_With_Operator] =
    useState(false);
  const [formula_End_With_Operator, setformula_End_With_Operator] =
    useState(false);
  const [inValidCharactersRegex, setinValidCharactersRegex] = useState(false);
  const [apiFormula, setApiFormula] = useState(""); // State for API formula
  const [createFormula, setCreateFormula] = useState("");
  const [tagIds, setTagIds] = useState([]); // State for storing tag IDs
  const [formulaArray, setFormulaArray] = useState([]);

  const selectedTags = props.SelectedTags;
  console.log("createFormula", createFormula);

  const [names, setnames] = useState([
    "cos()+sin()+tan()",
    "sin()+cos()+tan()",
    "tan()+cos()+sin()",
    "sin()",
    "sin()+sin()",
    "sin()+sin()+sin()",
    "sin()+sin()+sin()+sin()",
    "tan()+tan()+tan()+tan()+tan()+tan()",
    "cos()+cos()+cos()+cos()+cos()+cos()",
  ]);
  const TagName = props.Tag_Name_data ? props.Tag_Name_data : "";
  const Description = props.Tag_Description_data
    ? props.Tag_Description_data
    : "";
  const DeviceID = props.Device_ID ? props.Device_ID : "";

  const Button_disable = props.button_disable;
  const selectedTag = props.SelectedTags ? props.SelectedTags : [];

  console.log("Button_disable",Button_disable)

  useEffect(() => {
    try {
      if (props.addtag) {
        console.log("props.tags", props.addtag);
        handleButtonClick(props.addtag);
        props.onaddTag(props.addtag);
      }
    } catch (e) {
      console.log("Error from AddTag in Formula....", e);
    }

    if (props.removetag) {
      try {
        handleRemoveTag(props.removetag);
        props.onRemoveTag(props.removetag);
      } catch (e) {
        console.log(" error tag removing time", e);
      }
    }
  }, [props.addtag, props.removetag]);

  const data = props.tagConfData;

  console.log("fdnjdnf", data);

  useEffect(() => {
    try {
      if (selectedFormula) {
        // Define regex patterns
        const regexPatterns = {
          hasEmptyParentheses: /\(\s*\)/,
          multipleConsecutiveOperators: /(?:>=|<=|[+\-*/><]){2,}/,
          formulaStartsWithOperator: /^(>=|<=|[+*/\-><])/,
          formulaEndsWithOperator: /(>=|<=|[+*/\-><])$/,
          invalidCharacters: /[,?'";]/,
        };

        // Check conditions
        const results = {
          hasEmptyParentheses: regexPatterns.hasEmptyParentheses.test(selectedFormula),
          multipleConsecutiveOperators: regexPatterns.multipleConsecutiveOperators.test(selectedFormula),
          formulaStartsWithOperator: regexPatterns.formulaStartsWithOperator.test(selectedFormula),
          formulaEndsWithOperator: regexPatterns.formulaEndsWithOperator.test(selectedFormula),
          invalidCharactersRegex: regexPatterns.invalidCharacters.test(selectedFormula),
        };

        // Button should be enabled if formula is valid
        const shouldDisableButton = 
          results.hasEmptyParentheses ||
          results.multipleConsecutiveOperators ||
          results.formulaStartsWithOperator ||
          results.formulaEndsWithOperator ||
          results.invalidCharactersRegex;

        props.button_disable_reverse(shouldDisableButton);

        // Update other states
        setHasEmptyParentheses(results.hasEmptyParentheses);
        setmultiple_Consecutive_Operators(results.multipleConsecutiveOperators);
        setformula_Starts_With_Operator(results.formulaStartsWithOperator);
        setformula_End_With_Operator(results.formulaEndsWithOperator);
        setinValidCharactersRegex(results.invalidCharactersRegex);
      }

      if (selectedFormula === "") {
        props.button_disable_reverse(true);
      }
    } catch (e) {
      console.log("error from validation check", e);
      props.button_disable_reverse(true);
    }
  }, [selectedFormula]);

  useEffect(() => {
    console.log("selectedTag.....", selectedTag);
  }, [selectedTag]);

  const notifyError = (message) =>
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });

  const notifySuccess = (message) =>
    toast.success(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });

  useEffect(() => {
    handleFormulaUpdate();
  }, [selectedFormula,Button_disable]);

  const handleFormulaUpdate = () => {
    // Check if selectedFormula exists and is not empty
    if (!selectedFormula || selectedFormula.trim() === "") {
      console.error("Selected formula is undefined or empty");
      return;
    }

    // Sample data logs
    const data = props.tagConfData;

    // Parse the selectedFormula and extract tag names
    const formulaTags = selectedFormula
    .split(/(?:>=|<=|[+\-*/><])+/)
      .map((tag) => tag.trim());

    // Create a new formula with IDs
    let newFormula = selectedFormula;
    let collectedSoftTagIds = [];

    // Iterate through each tag in the formula
    formulaTags.forEach((tagName) => {
      // Find the corresponding tag in the data logs
      const matchingTag = data.find((item) => item.tag_name === tagName);

      // If the tag is found and is_soft_tag is true, replace it with its ID
      if (matchingTag && matchingTag.is_soft_tag) {
        newFormula = newFormula.replace(tagName, matchingTag.id);
        collectedSoftTagIds.push(matchingTag.id);
      }
    });

    console.log("collectedSoftTagIds", collectedSoftTagIds);
    setTagIds(collectedSoftTagIds);
    setCreateFormula(newFormula);
    // Log the updated formula
    console.log("Updated formula with IDs:", newFormula);

    // You can now store this new formula in a state or use it for further logic
    setApiFormula(newFormula);
  };

  const handleRemoveTag = (removetag) => {
    // Find the position of the last occurrence of the tag
    const tagIndex = selectedFormula.lastIndexOf(removetag);

    if (tagIndex !== -1) {
      // Find the position of the operator preceding this tag
      let operatorIndex = -1;
      for (let i = tagIndex - 1; i >= 0; i--) {
        const char = selectedFormula.charAt(i);
        if (char === "+" || char === "-" || char === "*" || char === "/") {
          operatorIndex = i;
          break;
        }
      }

      if (operatorIndex !== -1) {
        // Remove the substring from operatorIndex to tagIndex (inclusive)
        const updatedFormula =
          selectedFormula.substring(0, operatorIndex) +
          selectedFormula.substring(tagIndex + removetag.length);

        // Set the updated formula
        setselectedFormula(updatedFormula);
      } else {
        // If no operator found, simply remove the tag
        const updatedFormula =
          selectedFormula.substring(0, tagIndex) +
          selectedFormula.substring(tagIndex + removetag.length);

        // Set the updated formula
        setselectedFormula(updatedFormula);
      }
    }
  };

  const inputRef = useRef(null);

  async function CreateSoftTagFormula() {
    try {
      const params = {
        device_id: DeviceID,
        tag_name: TagName,
        tag_description: Description,
        formula: createFormula,
        softtag_list: tagIds,
        device_tag_list: selectedTag,
      };
      const CreateSoftTagApi = await createSoftTag(params);
      if (CreateSoftTagApi.data) {
        notifySuccess(CreateSoftTagApi.data.message);
        props.onClosePopup(false);
      }
      // console.log("CreateSoftTagApi", CreateSoftTagApi.data);
    } catch (e) {
      console.log("error in Create Soft Tag Formula:", e);
      if (e.response.data) {
        console.log(
          "error in Create Soft Tag Formula:",
          e.response.data.message
        );
        notifyError(e.response.data.message);
        // props.onClosePopup(true);
        props.handle_reverse_softagModal(true);
      } else {
        notifyError("Error in Create Soft Tag");
      }
    }
  }

  const dataasds = props.tagConfData;
  console.log("data", dataasds);
  const handleinput = (e) => {
    try {
      const inputValue = e.target.value.toLowerCase();
      setselectedFormula(e.target.value);
      const filteredNames = names.filter((name) =>
        name.toLowerCase().includes(inputValue)
      );
      setMatchList(filteredNames);
    } catch (e) {
      console.log("Error from handle input time", e);
    }
  };

  const handleselectlist = (e) => {
    try {
      setselectedFormula(e.target.getAttribute("value"));

      setMatchList("");
    } catch (e) {
      console.log("Error from handleselectlist", e);
    }
  };

  const listRender = () => {
    return (
      <ul className="dd-menu">
        {matchList.map((name, index) => (
          <li key={name} value={name} onClick={(e) => handleselectlist(e)}>
            {name}
          </li>
        ))}
      </ul>
    );
  };

  // useEffect(()=>{
  //   setApiFormula((prev)=>prev.sea)
  // })

  console.log("selctedFormula", selectedFormula);
  // function evaluateExpression(expression) {
  //   try {
  //     const result = evaluate(expression);
  //     return result;
  //   } catch (error) {
  //     console.error("Error evaluating expression:", error);
  //     return "Error";
  //   }
  // }

  const validation_Check = () => {
    let errors = [];

    // Add your existing checks here

    if (hasemptyParentheses) {
      errors.push("Please avoid using empty parentheses.");
    }
    if (multiple_Consecutive_Operators) {
      errors.push("Please remove consecutive operators like '++, --, **, //, >>, <<'.");
    }
    if (formula_Starts_With_Operator) {
      errors.push("Formulas should not start with an operator like '+, -, *, /, >, <'.");
    }
    if (formula_End_With_Operator) {
      errors.push("Formulas should not end with an operator like '+, -, *, /, >, <'.");
    }
    if (inValidCharactersRegex) {
      errors.push(
        "Invalid characters such as ', ;' are not allowed in the formula"
      );
    }

    const tags = selectedTags;
    const operators = selectedFormula.match(/(?:>=|<=|[+\-*/><])+/g);

    // Check if no operators found
    if (!operators) {
      errors.push("No operators found in the formula.");
    } else if (tags.length > 1) {
      for (let i = 0; i < tags.length - 1; i++) {
        if (!operators[i]) {
          errors.push("An operator is missing between tags.");
          break; // Exit the loop once an error is found
        }
      }
    }

    // Check if any additional tags are added and if there is an operator after adding a tag

    if (errors.length > 0) {
      const errorMessage = "Error: " + errors.join(", ");
      console.log(errorMessage);
      notifyError(errorMessage);
    } else {
      CreateSoftTagFormula();
    }
  };

  function handlesubmit() {
    try {
      if (selectedFormula && DeviceID) {
        // const result = evaluateExpression(selectedFormula);
        // setResult(result);
        validation_Check();
      } else if (!selectedFormula && DeviceID) {
        notifyError("Please Formula Field is Required");
      } else if (selectedFormula && !DeviceID) {
        notifyError("DeviceID is Not Found");
      } else if (!selectedFormula && !DeviceID) {
        notifyError("Formula and DeviceID is Required");
      } else {
        console.log("Error from handlesubmit");
      }
    } catch (Error) {
      console.log("Error From handle submit Formula ..:", Error);
    }
  }

  async function handleButtonClick(tag) {
    try {
      const tagToInsertAPI = props.selectSoftTag ? props.selectTagId : tag;
      const tagToInsertInput = tag;

      console.log("tagToInsertAPI (For API)", tagToInsertAPI);

      if (inputRef.current.selectionStart > 0) {
        const currentCursorPosition = inputRef.current.selectionStart;
        const updatedFormula =
          selectedFormula.slice(0, currentCursorPosition) +
          tagToInsertInput +
          selectedFormula.slice(currentCursorPosition);

        setselectedFormula(updatedFormula);

        setApiFormula((prev) => {
          const operators = selectedFormula.match(/(?:>=|<=|[+\-*/><])+/g) || [];
          const lastOperator = operators[operators.length - 1];

          let newApiFormula = prev;

          if (prev) {
            newApiFormula += lastOperator + tagToInsertAPI;
          } else {
            newApiFormula += tagToInsertAPI;
          }

          const newTagIds = newApiFormula.split(/(?:>=|<=|[+\-*/><])+/).filter((id) => id);

          const filteredTagIds = newTagIds.filter((id) => !isNaN(id));

          setTagIds(filteredTagIds);
          return newApiFormula;
        });

        console.log("updatedFormula (For Input)", updatedFormula);
        console.log("API Formula", apiFormula);
        console.log("tagIds", tagIds);

        await inputRef.current.focus();
        const newCursorPosition =
          currentCursorPosition + tagToInsertInput.length;
        inputRef.current.setSelectionRange(
          newCursorPosition,
          newCursorPosition
        );
      } else {
        setselectedFormula(tagToInsertInput);
        setApiFormula(tagToInsertAPI);

        if (!isNaN(tagToInsertAPI)) {
          setTagIds([tagToInsertAPI]);
        } else {
          setTagIds([]);
        }
      }
    } catch (error) {
      console.log("Error from select formula", error);
    }
  }

  return (
    <>
      <div className="App">
        <div className="calc-body">
          <div className="calc-title">Scientific Calculator</div>
          <div className="input-section">
            <input
              className="screen"
              type="text"
              onChange={(e) => handleinput(e)}
              value={selectedFormula}
              autocomplete="on"
              ref={inputRef}
              required
            />

            {matchList ? listRender() : null}
            <button
              className={`scientific-calc-btn ${
                Button_disable ? "Button_disable" : ""
              }`}
              onClick={() => {
                handlesubmit();
              }}
              disabled={Button_disable}
            >
              Submit
            </button>
            {/* <div className="output">Output: {Result ? Result : null}</div> */}
          </div>
        </div>
        <div className="variables"></div>
      </div>
    </>
  );
};

export const UpdateSoftTag = function SoftTagUpdate(props) {
  // const [Result, setResult] = useState();
  // const [selectedActualFormula, setselectedActualFormula] = useState();
  const [matchList, setMatchList] = useState();
  const [selectedFormula, setselectedFormula] = useState();

  const [hasemptyParentheses, setHasEmptyParentheses] = useState(false);
  const [multiple_Consecutive_Operators, setmultiple_Consecutive_Operators] =
    useState(false);
  const [formula_Starts_With_Operator, setformula_Starts_With_Operator] =
    useState(false);
  const [formula_End_With_Operator, setformula_End_With_Operator] =
    useState(false);
  const [inValidCharactersRegex, setinValidCharactersRegex] = useState(false);
  const [apiFormula, setApiFormula] = useState(props.formulaData); // State for API formula
  const [tagIds, setTagIds] = useState([]); // State for storing tag IDs
  const [updateFormula, setUpdateFormula] = useState("");

  const selectedTags = props.SelectedTags;

  console.log("tagIds", tagIds,props.updateSoftTagId);

  const [names, setnames] = useState([
    "cos()+sin()+tan()",
    "sin()+cos()+tan()",
    "tan()+cos()+sin()",
    "sin()",
    "sin()+sin()",
    "sin()+sin()+sin()",
    "sin()+sin()+sin()+sin()",
    "tan()+tan()+tan()+tan()+tan()+tan()",
    "cos()+cos()+cos()+cos()+cos()+cos()",
  ]);

  const DeviceID = props.Device_ID ? props.Device_ID : "";
  const Tag_Id = props.Tag_ID ? props.Tag_ID : "";
  const Formula = props.SoftTagFormula ? props.SoftTagFormula : "";
  const selectedTag = props.SelectedTags ? props.SelectedTags : [];

  const Button_disable = props.button_disable;

  useEffect(() => {
    try {
      if (props.addtag) {
        console.log("props.tags", props.addtag);
        handleButtonClick(props.addtag);
        props.onaddTag(props.addtag);
      }
    } catch (e) {
      console.log("Error from AddTag in Formula....", e);
    }

    if (props.removetag) {
      try {
        handleRemoveTag(props.removetag);
        props.onRemoveTag(props.removetag);
      } catch (e) {
        console.log(" error tag removing time", e);
      }
    }
  }, [props.addtag, props.removetag,Button_disable]);

  useEffect(() => {
    try {
      // if (selectedFormula) {
      //   console.log("selectedFormula....", selectedFormula);
      //   const hasEmptyParentheses = /\(\s*\)/.test(selectedFormula);
      //   console.log("hasEmptyParentheses", hasEmptyParentheses);
      //   props.button_disable_reverse(hasEmptyParentheses);
      // }

      if (selectedFormula) {
        // Define regex patterns once
        const regexPatterns = {
          hasEmptyParentheses: /\(\s*\)/,
          multipleConsecutiveOperators: /(?:>=|<=|[+\-*/><]){2,}/,
          formulaStartsWithOperator: /^(>=|<=|[+*/\-><])/,
          formulaEndsWithOperator: /(>=|<=|[+*/\-><])$/,
          invalidCharacters: /[,?'";]/,
        };

        // Check conditions and update state in a single operation
        const results = {
          hasEmptyParentheses:
            regexPatterns.hasEmptyParentheses.test(selectedFormula),
          multipleConsecutiveOperators:
            regexPatterns.multipleConsecutiveOperators.test(selectedFormula),
          formulaStartsWithOperator:
            regexPatterns.formulaStartsWithOperator.test(selectedFormula),
          formulaEndsWithOperator:
            regexPatterns.formulaEndsWithOperator.test(selectedFormula),
          invalidCharactersRegex:
            regexPatterns.invalidCharacters.test(selectedFormula),
        };
        console.log("selectedFormula....", selectedFormula);
        console.log("results..", results);
        console.log(
          "results..",
          results.hasEmptyParentheses &&
            results.multipleConsecutiveOperators &&
            results.formulaStartsWithOperator &&
            results.formulaEndsWithOperator &&
            results.invalidCharactersRegex
        );
        const button_disable_reverse_data =
          results.hasEmptyParentheses ||
          results.multipleConsecutiveOperators ||
          results.formulaStartsWithOperator ||
          results.formulaEndsWithOperator ||
          results.invalidCharactersRegex;
        props.button_disable_reverse(button_disable_reverse_data);
        setHasEmptyParentheses(results.hasEmptyParentheses);
        setmultiple_Consecutive_Operators(results.multipleConsecutiveOperators);
        setformula_Starts_With_Operator(results.formulaStartsWithOperator);
        setformula_End_With_Operator(results.formulaEndsWithOperator);
        setinValidCharactersRegex(results.invalidCharactersRegex);
      }

      if (selectedFormula == "") {
        console.log("................................nulll", selectedFormula);
        props.button_disable_reverse(true);
      }
    } catch (e) {
      console.log("error from hasEmptyParentheses check", e);
    }
  }, [selectedFormula, Button_disable]);

  useEffect(() => {
    setselectedFormula(Formula);
  }, [Formula]);

  const notifyError = (message) =>
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
      autoClose: 10000,
    });

  const notifySuccess = (message) =>
    toast.success(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });

  const handleRemoveTag = (removetag) => {
    // Find the position of the last occurrence of the tag
    const tagIndex = selectedFormula.lastIndexOf(removetag);

    if (tagIndex !== -1) {
      // Find the position of the operator preceding this tag
      let operatorIndex = -1;
      for (let i = tagIndex - 1; i >= 0; i--) {
        const char = selectedFormula.charAt(i);
        if (char === "+" || char === "-" || char === "*" || char === "/") {
          operatorIndex = i;
          break;
        }
      }

      if (operatorIndex !== -1) {
        // Remove the substring from operatorIndex to tagIndex (inclusive)
        const updatedFormula =
          selectedFormula.substring(0, operatorIndex) +
          selectedFormula.substring(tagIndex + removetag.length);

        // Set the updated formula
        setselectedFormula(updatedFormula);
      } else {
        // If no operator found, simply remove the tag
        const updatedFormula =
          selectedFormula.substring(0, tagIndex) +
          selectedFormula.substring(tagIndex + removetag.length);

        // Set the updated formula
        setselectedFormula(updatedFormula);
      }
    }
  };

  const inputRef = useRef(null);

  async function UpdateSoftTagFormula() {
    try {
      const params = {
        soft_tag_id: Tag_Id,
        formula: updateFormula,
        softtag_list: [...tagIds, props.updateSoftTagId],
        device_tag_list: selectedTag,
      };
      const UpdateSoftTagApi = await updateSoftTag(params);
      if (UpdateSoftTagApi.data) {
        notifySuccess(UpdateSoftTagApi.data.message);
        props.onClosePopup(false);
      }
      // console.log("CreateSoftTagApi", CreateSoftTagApi.data);
    } catch (e) {
      console.log("error in Create Soft Tag Formula:", e);
      notifyError("Error in Update Soft Tag");
    }
  }

  const handleinput = (e) => {
    try {
      const inputValue = e.target.value.toLowerCase();
      setselectedFormula(e.target.value);
      const filteredNames = names.filter((name) =>
        name.toLowerCase().includes(inputValue)
      );
      setMatchList(filteredNames);
    } catch (e) {
      console.log("Error from handle input time", e);
    }
  };

  const handleselectlist = (e) => {
    try {
      setselectedFormula(e.target.getAttribute("value"));

      setMatchList("");
    } catch (e) {
      console.log("Error from handleselectlist", e);
    }
  };
  const listRender = () => {
    return (
      <ul className="dd-menu">
        {matchList.map((name, index) => (
          <li key={name} value={name} onClick={(e) => handleselectlist(e)}>
            {name}
          </li>
        ))}
      </ul>
    );
  };

  const validation_Check = () => {
    let errors = [];

    if (hasemptyParentheses) {
      errors.push("Empty parentheses ()");
    }
    if (multiple_Consecutive_Operators) {
      errors.push("Please remove consecutive operators like '++, --, **, //, >>, <<'.");
    }
    if (formula_Starts_With_Operator) {
      errors.push("Formulas should not start with an operator like '+, -, *, /, >, <'.");
    }
    if (formula_End_With_Operator) {
      errors.push("Formulas should not end with an operator like '+, -, *, /, >, <'.");
    }
    if (inValidCharactersRegex) {
      errors.push("Invalid characters ',  ; '");
    }

    const tags = selectedTags;
    const operators = selectedFormula.match(/(?:>=|<=|[+\-*/><])+/g);


    // Check if no operators found
    if (!operators) {
      errors.push("No operators found in the formula.");
    } else if (tags.length > 1) {
      for (let i = 0; i < tags.length - 1; i++) {
        if (!operators[i]) {
          errors.push("An operator is missing between tags.");
          break; // Exit the loop once an error is found
        }
      }
    }
    if (errors.length > 0) {
      const errorMessage = "Error: " + errors.join(", ");
      console.log(errorMessage);
      notifyError(errorMessage);
    } else {
      UpdateSoftTagFormula();
    }
  };

  function handlesubmit() {
    try {
      if (selectedFormula && DeviceID) {
        // const result = evaluateExpression(selectedFormula);
        // setResult(result);

        validation_Check();
      } else if (!selectedFormula && DeviceID) {
        notifyError("Please Formula Field is Required");
      } else if (selectedFormula && !DeviceID) {
        notifyError("DeviceID is Not Found");
      } else if (!selectedFormula && !DeviceID) {
        notifyError("Formula and DeviceID is Required");
      } else {
        console.log("Error from handlesubmit");
      }
    } catch (Error) {
      console.log("Error From handle submit Formula ..:", Error);
    }
  }

  const data = props.tagConfData;

  console.log("datadsfdsf", data);

  useEffect(() => {
    if (typeof selectedFormula === "string") {
      const formulaTags = selectedFormula.match(/\b[A-Za-z0-9_]+\b/g) || [];
  
      let matchingSoftTagIds = []; // Initialize empty array
      const updatedFormula = formulaTags.reduce((formula, tag) => {
        const matchingTag = data.find(
          (item) =>
            item.device_tag_list.includes(tag) ||
            (item.is_soft_tag &&
              item.soft_tag.some((soft) => soft.tag_name === tag))
        );
  
        if (matchingTag && matchingTag.is_soft_tag) {
          const softTag = matchingTag.soft_tag.find(
            (soft) => soft.tag_name === tag
          );
  
          if (softTag) {
            console.log("softTag", softTag);

            matchingSoftTagIds.push(softTag.tag);
            const tagRegex = new RegExp(`\\b${tag}\\b`, "g");
            return formula.replace(tagRegex, softTag.tag);
          }
        }
  
        return formula; 
      }, selectedFormula);
  
      console.log("matchingSoftTagIds", matchingSoftTagIds);
      setTagIds(matchingSoftTagIds);
  
      setUpdateFormula(updatedFormula);
      console.log("Updated Formula:", updatedFormula); 
    } else {
      console.log("Invalid or undefined selectedFormula");
    }
  }, [selectedFormula, data]); 
  

  async function handleButtonClick(tag) {
    try {
      const matchingTag = props.tagConfData.find(
        (item) =>
          item.device_tag_list.includes(tag) ||
          (item.is_soft_tag &&
            item.soft_tag.some((soft) => soft.tag_name === tag))
      );

      let tagToInsertAPI = tag; // Default to tag name
      let tagToInsertInput = tag; // Default to tag name for input

      if (matchingTag && matchingTag.is_soft_tag) {
        const softTag = matchingTag.soft_tag.find(
          (soft) => soft.tag_name === tag
        );
        if (softTag) {
          tagToInsertAPI = String(softTag.tag); // Use tag ID for API and ensure it's a string
        }
      } else {
        tagToInsertAPI = props.selectSoftTag ? String(props.selectTagId) : tag; // Ensure it's a string
      }

      if (inputRef.current.selectionStart > 0) {
        const currentCursorPosition = inputRef.current.selectionStart;

        // Build the updated formula for display
        const updatedFormula =
          selectedFormula.slice(0, currentCursorPosition) +
          tagToInsertInput +
          selectedFormula.slice(currentCursorPosition);

        // Check for consecutive operators
        const cleanFormula = updatedFormula.replace(
          /(\+{2,}|\-{2,}|\*{2,}\/{2,})/g,
          (match) => match[0]
        ); // Replace consecutive operators with a single operator

        setselectedFormula(cleanFormula);

        // Build the API formula with IDs
        setApiFormula((prev) => {
          const operators = selectedFormula.match(/(?:>=|<=|[+\-*/><])+/g) || [];
          const lastOperator = operators[operators.length - 1] || "";

          let newApiFormula = updateFormula || ""; // Start with an empty string if prev is undefined

          // Check for consecutive operators before adding
          if (prev) {
            if (lastOperator && lastOperator !== lastOperator[0]) {
              // Ensure last operator is not duplicate
              newApiFormula += lastOperator + String(tagToInsertAPI); // Ensure it's a string
            } else {
              newApiFormula += String(tagToInsertAPI); // Just add the tag
            }
          } else {
            newApiFormula += String(tagToInsertAPI); // Ensure it's a string
          }

          console.log("newApiFormula", newApiFormula);
          const newTagIds = newApiFormula.split(/(?:>=|<=|(?:>=|<=|[+\-*/><]))+/).filter((id) => id);
          const filteredTagIds = newTagIds.filter((id) => !isNaN(id));

          setTagIds(filteredTagIds);
          return newApiFormula;
        });

        await inputRef.current.focus();
        const newCursorPosition =
          currentCursorPosition + tagToInsertInput.length;
        inputRef.current.setSelectionRange(
          newCursorPosition,
          newCursorPosition
        );
      } else {
        setselectedFormula(tagToInsertInput);
        setApiFormula(String(tagToInsertAPI)); // Ensure it's a string

        if (!isNaN(tagToInsertAPI)) {
          setTagIds([tagToInsertAPI]);
        } else {
          setTagIds([]);
        }
      }
    } catch (error) {
      console.log("Error from select formula", error);
    }
  }

  return (
    <>
      <div className="App">
        <div className="calc-body">
          <div className="calc-title">Scientific Calculator</div>
          <div className="input-section">
            <input
              className="screen"
              type="text"
              onChange={(e) => handleinput(e)}
              value={selectedFormula}
              autocomplete="on"
              ref={inputRef}
              required
            />

            {matchList ? listRender() : null}
            <button
              className={`scientific-calc-btn ${
                Button_disable ? "Button_disable" : ""
              }`}
              onClick={() => {
                handlesubmit();
              }}
              disabled={Button_disable}
            >
              Submit
            </button>
            {/* <div className="output">Output: {Result ? Result : null}</div> */}
          </div>
        </div>
        <div className="variables"></div>
      </div>
    </>
  );
};